import type { LocalAuthUser, UserRole } from '../data/types';

export interface ManagedUser {
  id: string;
  email: string;
  displayName: string;
  isActive: boolean;
  role: UserRole;
  preferences?: LocalAuthUser['preferences'] | null;
  createdAt: string;
  updatedAt: string;
}

export const roleLabels: Record<UserRole, string> = {
  SUPERADMIN: '0 Superadmin',
  ADMIN: '1 Admin',
  MANAGER: '2 Manager',
  USER: '3 User',
};

const roleLevels: Record<UserRole, number> = {
  SUPERADMIN: 0,
  ADMIN: 1,
  MANAGER: 2,
  USER: 3,
};

export function getRoleLevel(role: UserRole): number {
  return roleLevels[role];
}

export function canSeeAppMenu(user: LocalAuthUser | null | undefined): boolean {
  return user?.role !== 'USER';
}

export function canDeleteScenario(user: LocalAuthUser | null | undefined): boolean {
  return user?.role !== 'USER';
}

export function canForceScenarioTakeover(user: LocalAuthUser | null | undefined): boolean {
  return user?.role === 'SUPERADMIN' || user?.role === 'ADMIN';
}

export function canSetDefaultScenario(user: LocalAuthUser | null | undefined): boolean {
  return user?.role !== 'USER';
}

export function canManageUsers(user: LocalAuthUser | null | undefined): boolean {
  return Boolean(user && user.role !== 'USER');
}

export function canAssignRole(actorRole: UserRole, targetRole: UserRole): boolean {
  if (actorRole === 'SUPERADMIN') {
    return true;
  }
  if (actorRole === 'ADMIN') {
    return targetRole !== 'SUPERADMIN';
  }
  if (actorRole === 'MANAGER') {
    return targetRole === 'MANAGER' || targetRole === 'USER';
  }
  return false;
}

export function getAssignableRoles(user: LocalAuthUser | null | undefined): UserRole[] {
  if (!user) {
    return [];
  }

  return (Object.keys(roleLabels) as UserRole[]).filter((role) => canAssignRole(user.role, role));
}
